import { update, reset } from "../../viewmodel/accountsetting/accountSettingViewModel";


const init = () => {
    return async (dispatch, getState) => {
        dispatch(update({}))
    }
}

export default {
    update,
    reset,
    init,
}